import { Badges } from '../../../components/Badges';
import { Box, Icon, Image, Stack, Text, styled } from '@qcx/ui';
import { Link } from '../../../components/Link';
import { SimpleArticle } from '@atreus/data';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { route } from '../../../route';
import { safeRenderHtml } from '../../../lib/safe-render-html.lib';

export interface MostReadNewsProps {
  articles: SimpleArticle[];
}

export const MostReadNews = ({ articles }: MostReadNewsProps) => {
  return (
    <Box
      css={{
        flexCol: true,
        gap: '$4',
        '@md': {
          flexWrap: 'wrap',
          flexDirection: 'row',
          justifyContent: 'start',
          gap: 0
        }
      }}
    >
      {articles.map(post => (
        <Link
          key={post.slug}
          css={{ color: '$text' }}
          to={route('news-show', {
            slug: post.slug
          })}
        >
          <Box
            css={{
              flexRow: true,
              gap: '$4',
              mt: '$3',
              '@md': {
                flexCol: true,
                w: '$60',
                gap: '$3',
                mb: '$3'
              }
            }}
          >
            <StyledCardBody flow={'row'}>
              {post.image ? (
                <StyledImage
                  width={288}
                  height={96}
                  alt="news image"
                  src={post.image}
                  noAspectRatio
                />
              ) : (
                <StyledImageEmpty>
                  <Icon
                    css={{ color: '$neutral700' }}
                    icon={faImage}
                    size="5xl"
                  />
                </StyledImageEmpty>
              )}
            </StyledCardBody>
            <Stack css={{ pr: '$4' }} flow="column" gap="$3">
              {post.editorials && (
                <Badges badgesCount={1} items={post.editorials} />
              )}
              <Text
                dangerouslySetInnerHTML={{
                  __html: safeRenderHtml(post.title)
                }}
                variant={{ '@initial': 'sm', '@md': 'md' }}
                weight={'semibold'}
              />
            </Stack>
          </Box>
        </Link>
      ))}
    </Box>
  );
};
const StyledImage = styled(Image, {
  w: '$full',
  height: 96,
  d: 'flex',
  '& img': {
    objectFit: 'cover'
  },
  rounded: '$4xl',
  '@xs': { height: 96, w: 96 },
  '@sm': { height: 122, w: 216 }
});

const StyledImageEmpty = styled(Box, {
  w: '$full',
  height: 96,
  bg: '$neutral50',
  rounded: '$4xl',
  flexCenter: true,
  aspectRatio: '1 / 0',
  '@xs': { height: 96, w: 96 },
  '@sm': { height: 122, w: 216 }
});

const StyledCardBody = styled('div', {
  d: 'flex',
  alignItems: 'stretch',
  variants: {
    flow: {
      row: {
        flexDir: 'row',
        [`& ${StyledImage}`]: {
          maxW: 280,
          pb: 0,
          '& img': {
            h: '$full'
          }
        }
      },
      column: {
        flexDir: 'column',
        [`& ${StyledImage}`]: {
          maxW: 'none',
          '& img': {
            position: 'absolute',
            inset: 0
          }
        }
      }
    }
  },
  defaultVariants: {
    flow: 'column'
  }
});
